import axios from 'axios';
import { generateUrl } from '../config/AppConfig';

/**
 * It is generic Get method for calling API and returning
 * @param endPoint It is API end point.
 * @param _params It is optional parameter.
 * @param _key It is an optional parameter.
 * @returns
 */
export async function getData(
  endPoint: string,
  params?: any,
  key?: any,
  otherOptions?: any,
): Promise<any> {
  const apiBaseUrl = await apiBase(endPoint, key);
  return axios.get(apiBaseUrl, { params, ...otherOptions });
}

/**
 * It is generic Post method for calling API.
 * @param endPoint It is API end point name.
 * @param data it is for body payload.
 * @returns
 */
export async function postData(endPoint: string, data: any): Promise<any> {
  const apiBaseUrl = await apiBase(endPoint);
  return await axios.post(apiBaseUrl, data);
}
/**
 * It is generic Post method for calling API.
 * @param endPoint It is API end point name.
 * @param data it is for body payload.
 * @returns
 */
export async function updateData(
  endPoint: string,
  data: any,
  key?: any,
): Promise<any> {
  const apiBaseUrl = await apiBase(endPoint, key);
  return axios.put(apiBaseUrl, data);
}
/**
 * It is generic Delete method for calling API.
 * @param endPoint It is API end point name.
 * @param data it is for body payload.
 * @returns
 */
export async function deleteData(
  endPoint: string,
  data: any,
  key?: any,
  queryParams?: string,
): Promise<any> {
  const apiBaseUrl = await apiBase(endPoint, key, queryParams);
  return axios.delete(apiBaseUrl, data);
}
/**
 * This method will take care API base url and provided api end point
 * @param endPoint api end point name for getting the base url
 * @returns
 */
export async function apiBase(
  endPoint: string,
  key?: any,
  queryParams?: string,
): Promise<any> {
  const config = await generateUrl(endPoint, key, queryParams);
  return config;
}
